export default __webpack_public_path__ + "static/media/917.0713ccca.png";